<div class="load-description">
  <div class="frame">
    <img [src]="getLoadIcon()" />
  </div>
  <div class="load-name">
    <h3>{{ load.name | translate }}</h3>
    <span>
      {{
      project.options?.unit === 'mm'
      ? (load.length * 10) + ' x ' + (load.width * 10) + ' x ' + (load.height * 10)
      : load.length + ' x ' + load.width + ' x ' + load.height
      }} {{ project.options?.unit }} |
      {{ load.weight }} {{ project.options?.unit === 'cm' || project.options?.unit === 'mm' ? 'kg' : 'lb' }}
    </span>
  </div>
</div>
@if (isVarioFloor) {
  <div class="button" (click)="changeFloor()">
    <div class="frame">
      <gl-icon [name]="'arrow'"></gl-icon>
    </div>
    {{ 'change_floor' | translate }}
  </div>
}
@if (!load.stacked && !load.unloaded && isShow) {
  <div>
    @if (!isRotated) {
      <div
        class="button"
        (click)="changeStacking()"
        [class.active]="load.stacking && !load.maxLoadsOnTop"
        >
        <div class="frame">
          <gl-slide-toggle [ngModel]="load.stacking"></gl-slide-toggle>
        </div>
        @if (!load.maxLoadsOnTop) {
          <span>{{ 'stack' | translate }}</span>
        }
        @if (load.maxLoadsOnTop) {
          <span
            >{{ 'stack_quantity_info' | translate }} {{ load.maxLoadsOnTop }})</span
            >
          }
        </div>
      }
      @if (load.loadType !== 1 && !isRotated && load.maxLoadsOnTop) {
        <div
          class="button"
          (click)="rotate()"
          >
        </div>
      }
      @if (!isRotated && load.loadType !== 1) {
        <div class="button" (click)="rotate()">
          <div class="frame">
            <gl-icon [name]="'rotate'"></gl-icon>
          </div>
          {{ 'rotate_horizontally' | translate }}
        </div>
      }
      @if (areLoadBaseDimensionsSame() && load.loadType !== 1 && load.loadType !== 2 && !isRotated) {
        <div
          class="button"
          (click)="flip()"
          >
          <div class="frame">
            <gl-icon [name]="'flip'"></gl-icon>
          </div>
          {{ 'flip' | translate }}
        </div>
      }
      @if (
        !areLoadBaseDimensionsSame() &&
        !isPallet &&
        load.loadType !== 1 &&
        load.loadType !== 2 &&
        !isRotated
        ) {
        <div
          class="button"
          (click)="flipShorter()"
          >
          <div class="frame">
            <gl-icon [name]="'flip-shorter'"></gl-icon>
          </div>
          {{ 'flip_shorter' | translate }}
        </div>
      }
      @if (
        !areLoadBaseDimensionsSame() &&
        !isPallet &&
        load.loadType !== 1 &&
        load.loadType !== 2 &&
        !isRotated
        ) {
        <div
          class="button"
          (click)="flipLonger()"
          >
          <div class="frame">
            <gl-icon [name]="'flip-longer'"></gl-icon>
          </div>
          {{ 'flip_longer' | translate }}
        </div>
      }
      @if (load.loadType !== 1) {
        <div class="button" (click)="mouseRotateX()">
          <div class="frame">
            <gl-icon [name]="'flip-shorter'"></gl-icon>
          </div>
          {{ 'rotate_around_axis' | translate: { axis: 'X' } }}
        </div>
      }
      @if (load.loadType !== 1) {
        <div class="button" (click)="mouseRotateY()">
          <div class="frame">
            <gl-icon [name]="'rotate'"></gl-icon>
          </div>
          {{ 'rotate_around_axis' | translate: { axis: 'Y' } }}
        </div>
      }
      <div class="button" (click)="delete()">
        <div class="frame">
          <gl-icon class="delete" [name]="'delete'"></gl-icon>
        </div>
        {{ 'delete_load' | translate }}
      </div>
    </div>
  }
